module.exports = __webpack_public_path__ + "static/media/telegramArticle.cbb277df.svg";